(() => {
  'use strict';
  if (window.__tpDingDoongCheckoutSyncV5) return;
  window.__tpDingDoongCheckoutSyncV5 = true;

  const cartPage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname);
  const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const cartUrl = rootPath + 'cart';
  const checkoutSelector = 'button[name="checkout"], #checkout.cart__checkout-button, button.cart__checkout-button';
  const acceleratedSelector = '.additional-checkout-buttons, .cart__additional-checkout-buttons, shopify-accelerated-checkout-cart';
  let resuming = false;
  let pending = null;
  let refreshTimer = 0;
  let observingApp = null;

  const calendarMonths = {januar:1,jan:1,january:1,februar:2,feb:2,february:2,maerz:3,marz:3,märz:3,mar:3,march:3,april:4,apr:4,mai:5,may:5,juni:6,jun:6,june:6,juli:7,jul:7,july:7,august:8,aug:8,september:9,sep:9,sept:9,oktober:10,okt:10,october:10,oct:10,november:11,nov:11,dezember:12,dez:12,december:12,dec:12};
  const isoFromParts = (y, m, d) => {
    const year = Number(y), month = Number(m), day = Number(d);
    const dt = new Date(Date.UTC(year, month - 1, day));
    if (year < 2025 || year > 2038 || dt.getUTCFullYear() !== year || dt.getUTCMonth() !== month - 1 || dt.getUTCDate() !== day) return '';
    return [String(year), String(month).padStart(2, '0'), String(day).padStart(2, '0')].join('-');
  };
  const parseDate = value => {
    const text = String(value || '').trim();
    let m = text.match(/\b(20\d{2})[-/.](\d{1,2})[-/.](\d{1,2})\b/);
    if (m) return isoFromParts(m[1], m[2], m[3]);
    m = text.match(/\b(\d{1,2})[./-](\d{1,2})[./-](20\d{2})\b/);
    if (m) return isoFromParts(m[3], m[2], m[1]);
    m = text.match(/(\d{1,2})\.?\s+([a-zäöü]+)\.?,?\s+(20\d{2})/i);
    if (m && calendarMonths[m[2].toLowerCase()]) return isoFromParts(m[3], calendarMonths[m[2].toLowerCase()], m[1]);
    m = text.match(/([a-zäöü]+)\.?\s+(\d{1,2}),?\s+(20\d{2})/i);
    if (m && calendarMonths[m[1].toLowerCase()]) return isoFromParts(m[3], calendarMonths[m[1].toLowerCase()], m[2]);
    return '';
  };
  const slashDate = iso => {
    const [year, month, day] = iso.split('-');
    return [day, month, year].join('/');
  };
  const setState = value => {
    document.documentElement.dataset.tpDingDoongDateSync = value;
  };
  const showMessage = message => {
    if (!cartPage) return;
    const anchor = document.querySelector('.cart__ctas') || document.querySelector('#checkout');
    if (!anchor) return;
    let node = document.querySelector('[data-tp-checkout-date-notice]');
    if (!node) {
      node = document.createElement('div');
      node.dataset.tpCheckoutDateNotice = '';
      node.setAttribute('role', 'alert');
      node.style.cssText = 'margin:8px 0 12px;padding:12px 14px;border:1px solid #e5b1a5;border-left:4px solid #ba3927;border-radius:10px;background:#fff6f3;color:#61241b;font-size:13px;line-height:1.5;';
      anchor.before(node);
    }
    node.textContent = message;
    node.scrollIntoView?.({block:'nearest',behavior:'smooth'});
  };
  const clearMessage = () => document.querySelector('[data-tp-checkout-date-notice]')?.remove();
  const getCart = async () => {
    const response = await fetch(rootPath + 'cart.js', {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error('Der Warenkorb konnte nicht gelesen werden. Bitte versuche es erneut.');
    return response.json();
  };
  const deepRoots = () => {
    const roots = [document];
    for (let i = 0; i < roots.length; i += 1) {
      roots[i].querySelectorAll?.('*').forEach(element => {
        if (element.shadowRoot && !roots.includes(element.shadowRoot)) roots.push(element.shadowRoot);
      });
    }
    return roots;
  };
  const dingDoongRoot = () => {
    for (const root of deepRoots()) {
      const app = root.querySelector?.('#dingdoong-embedded-render-root');
      if (app) return app;
    }
    return null;
  };
  const dateFromCalendar = channel => {
    const app = dingDoongRoot();
    if (!app) return '';
    const pickup = channel === 'PICKUP';
    const openers = Array.from(app.querySelectorAll('.ot-dingdoong-calendar__popover-button, button[aria-label], [role="button"][aria-label]'));
    const match = openers.find(element => {
      const label = (String(element.textContent || '') + ' ' + String(element.getAttribute('aria-label') || '')).toLowerCase();
      return pickup
        ? /abholdatum|abholtermin|pickup date/.test(label)
        : /lieferdatum|liefertermin|delivery date|shipping date/.test(label);
    });
    return match ? parseDate(String(match.textContent || '') + ' ' + String(match.getAttribute('aria-label') || '')) : '';
  };
  const channelFor = attributes => {
    const appChannel = String(attributes.ot_channel || '').toUpperCase();
    if (appChannel === 'PICKUP' || appChannel === 'SHIPPING') return appChannel;
    const saved = String(attributes['Checkout channel'] || '').toUpperCase();
    if (saved === 'PICKUP' || saved === 'SHIPPING') return saved;
    if (parseDate(attributes['Pickup date']) || parseDate(attributes.Abholdatum)) return 'PICKUP';
    if (parseDate(attributes['Shipping date']) || parseDate(attributes.Versanddatum)) return 'SHIPPING';
    return '';
  };
  // DingDoong schreibt sein eigenes 'Shipping date'/'Pickup date' unmittelbar in
  // cart.attributes. Dies ist die Primärquelle; die sichtbare Kalenderbeschriftung
  // ist lediglich eine zusätzliche Plausibilitätskontrolle.
  const inspect = async () => {
    const cart = await getCart();
    const attributes = cart.attributes || {};
    if (!cart.item_count) throw new Error('Dein Warenkorb ist leer.');

    const channel = channelFor(attributes);
    if (!channel) throw new Error('Bitte wähle zuerst in DingDoong die Versand- oder Abholart aus.');
    const pickup = channel === 'PICKUP';
    const primaryKey = pickup ? 'Pickup date' : 'Shipping date';
    const secondaryKey = pickup ? 'Abholdatum' : 'Versanddatum';
    const primaryValue = String(attributes[primaryKey] || '').trim();
    const primaryDate = parseDate(primaryValue);
    const secondaryDate = parseDate(attributes[secondaryKey]);
    const app = dingDoongRoot();
    const visibleDate = app ? dateFromCalendar(channel) : '';

    // Nur das app-eigene Attribut gilt als Beleg einer DingDoong-Auswahl.
    // Ein vom Bestellpiloten übernommener Wert allein genügt nicht.
    if (!primaryDate) {
      throw new Error('DingDoong hat noch keinen gültigen Termin im Warenkorb gespeichert. Bitte wähle das Datum im Kalender erneut.');
    }
    // Konflikte werden nicht stillschweigend mit einem anderen Datum überschrieben.
    if (visibleDate && visibleDate !== primaryDate) {
      throw new Error('Das sichtbare Kalenderdatum stimmt noch nicht mit DingDoong überein. Bitte warte kurz und prüfe den Termin erneut.');
    }
    if (secondaryDate && secondaryDate !== primaryDate) {
      throw new Error('DingDoong-Datum und bisheriges Warenkorbdatum unterscheiden sich. Bitte wähle das Datum im Kalender erneut, bevor du zur Kasse gehst.');
    }
    const otherPrimary = parseDate(attributes[pickup ? 'Shipping date' : 'Pickup date']);
    if (otherPrimary && !String(attributes.ot_channel || '').trim()) {
      throw new Error('Es sind widersprüchliche Versand- und Abholtermine vorhanden. Bitte wähle die gewünschte Lieferart erneut.');
    }

    if (pickup) {
      const location = String(attributes.Location || attributes.Abholstandort || '').trim();
      const time = String(attributes['Pickup time'] || '').trim();
      if (!location) throw new Error('Für die Abholung fehlt der Standort. Bitte wähle einen Abholstandort.');
      if (!time) throw new Error('Für die Abholung fehlt das Zeitfenster. Bitte wähle eine Abholzeit.');
    }

    const date = primaryDate;
    const normalizedDate = slashDate(date);
    const changes = {};
    // Die nativen DingDoong-Felder NICHT umformatieren. Shopify-DingDoong
    // benötigt sie z.B. als YYYY-MM-DD. Nur die eigenen Anzeige-Aliase anpassen.
    if (attributes[secondaryKey] !== normalizedDate) changes[secondaryKey] = normalizedDate;
    if (attributes['Checkout channel'] !== channel) changes['Checkout channel'] = channel;
    for (const staleKey of (pickup ? ['Shipping date','Versanddatum'] : ['Pickup date','Abholdatum'])) {
      if (attributes[staleKey]) changes[staleKey] = '';
    }
    if (!pickup && attributes['Pickup time']) changes['Pickup time'] = '';

    if (attributes.tp_date_verified !== 'YES') changes.tp_date_verified = 'YES';
    if (attributes.tp_confirmed_date !== normalizedDate) changes.tp_confirmed_date = normalizedDate;
    if (attributes.tp_confirmed_channel !== channel) changes.tp_confirmed_channel = channel;
    const source = visibleDate ? 'DINGDOONG_CART_AND_CALENDAR' : 'DINGDOONG_CART';
    if (attributes.tp_date_source !== source) changes.tp_date_source = source;
    const confirmedTime = pickup ? String(attributes['Pickup time'] || '').trim() : '';
    if (String(attributes.tp_confirmed_time || '') !== confirmedTime) changes.tp_confirmed_time = confirmedTime;

    return {attributes, changes, channel, date, primaryKey, secondaryKey};
  };
  let lastError = '';
  const sync = async () => {
    if (pending) return pending;
    lastError = '';
    setState('pending');
    pending = (async () => {
      const inspected = await inspect();
      if (Object.keys(inspected.changes).length) {
        const response = await fetch(rootPath + 'cart/update.js', {
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({attributes:{...inspected.attributes,...inspected.changes}})
        });
        if (!response.ok) throw new Error('Der gewählte Termin konnte nicht im Warenkorb gespeichert werden. Bitte erneut versuchen.');
      }
      const verified = await getCart();
      const saved = verified.attributes || {};
      if (parseDate(saved[inspected.primaryKey]) !== inspected.date || parseDate(saved[inspected.secondaryKey]) !== inspected.date || saved['Checkout channel'] !== inspected.channel || saved.tp_date_verified !== 'YES') {
        throw new Error('Der Termin wurde nicht eindeutig übernommen. Bitte wähle ihn erneut und versuche es noch einmal.');
      }
      clearMessage();
      setState('ready');
      return true;
    })().catch(error => {
      lastError = String(error?.message || 'Unbekannter Terminfehler');
      setState('error');
      showMessage(error?.message || 'Bitte überprüfe den gewählten Liefer- oder Abholtermin.');
      return false;
    }).finally(() => {pending = null;});
    return pending;
  };
  const schedule = (delay = 700) => {
    if (!cartPage) return;
    setState('pending');
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {sync();}, delay);
  };

  document.addEventListener('click', event => {
    if (resuming) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const checkout = target.closest(checkoutSelector);
    if (checkout) {
      if (!cartPage) {
        if (checkout.closest('.cart-drawer, cart-drawer-component, cart-items-component, #header-group')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          location.assign(cartUrl);
        }
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      sync().then(ok => {
        if (!ok || !checkout.isConnected) return;
        resuming = true;
        try {checkout.click();} finally {resuming = false;}
      });
      return;
    }
    if (!cartPage) return;
    if (target.closest(acceleratedSelector) && document.documentElement.dataset.tpDingDoongDateSync !== 'ready') {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage('Bitte zuerst den gewünschten Liefer- oder Abholtermin im Kalender bestätigen.');
      return;
    }
    if (target.closest('#dingdoong-embedded-render-root')) schedule(950);
  }, true);

  document.addEventListener('submit', event => {
    if (resuming || !cartPage) return;
    const button = event.submitter;
    if (!button?.matches?.(checkoutSelector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync().then(ok => {
      if (!ok) return;
      resuming = true;
      try {event.target.requestSubmit(button);} finally {resuming = false;}
    });
  }, true);

  const start = () => {
    if (!cartPage) return;
    setState('pending');
    document.addEventListener('change', event => {
      if (event.target instanceof Element && event.target.closest('#dingdoong-embedded-render-root')) schedule(700);
    }, true);
    const observer = new MutationObserver(() => schedule(800));
    const attach = () => {
      const app = dingDoongRoot();
      if (app && app !== observingApp) {
        observer.disconnect();
        observingApp = app;
        observer.observe(app, {subtree:true,childList:true,attributes:false});
        schedule(500);
      }
    };
    const appTimer = setInterval(attach, 1200);
    setTimeout(() => {clearInterval(appTimer);}, 24000);
    attach();
    schedule(1400);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();